<template>
  <div v-if="previousProductPath" class="mb-6 flex justify-center">
    <NuxtLink class="btn btn-outline btn-rounded" :to="previousProductPath" :title="t['w.saal.back-to-product']()">
      <div class="flex items-center justify-center">
        <Icon class="size-6" name="arrow-left" />
        {{ t['w.saal.back-to-product']() }}
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import * as t from '~/messages'
import Icon from '~/components/icon/Icon.vue'

const route = useRoute()
const router = useRouter()

const previousProductPath = computed(() => {
  const path = typeof route.query.previousProductPath === 'string' ? route.query.previousProductPath : null

  if (path) {
    const resolved = router.resolve(path)

    if (resolved.name === 'product') {
      return resolved.path
    }
  }

  return null
})
</script>
